export enum RelationType {
  pet = 'pet',
  parent = 'parent',
  friend = 'friend',
}
